// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1050":"4eb844db3304d6be","2888":"41acfae5d2f6e87b"}[chunkId] + ".css";
};